{% block acris_blogs_index %}
    <sw-page class="acris-blog-index sw-settings-index">
        {% block acris_blogs_index_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_blogs_index_smart_bar_header_title %}
                    <h2>
                        {% block acris_blogs_index_smart_bar_header_title_text %}
                            {{ $tc('acris-blogs.index.textHeadline') }}
                        {% endblock %}
                    </h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blogs_index_content %}
            <template #content>
                {% block acris_blogs_index_content_card_view %}
                    <sw-card-view>
                        {% block acris_blogs_index_content_card %}
                            <mt-card position-identifier="acris-blogs_index__card">
                                {% block acris_blogs_index_content_grid %}
                                    <div class="acris-settings-content-grid sw-settings__content-grid sw-settings__tabs">
                                        {% block acris_blogs_index_card_item %}
                                            {% block acris_blog %}
                                                <sw-settings-item
                                                        :label="$tc('acris-blog.general.mainMenuItemGeneral')"
                                                        :to="{ name: 'acris.blog.index' }"
                                                        class="acris-settings-item">
                                                    <template #icon>
                                                        <mt-icon name="regular-content"></mt-icon>
                                                    </template>
                                                </sw-settings-item>
                                            {% endblock %}
                                            {% block acris_blog_group %}
                                                <sw-settings-item
                                                        :label="$tc('acris-blog-group.general.mainMenuItemGeneral')"
                                                        :to="{ name: 'acris.blog.group.index' }"
                                                        class="acris-settings-item">
                                                    <template #icon>
                                                        <mt-icon name="regular-list"></mt-icon>
                                                    </template>
                                                </sw-settings-item>
                                            {% endblock %}
                                            {% block acris_blog_author %}
                                                <sw-settings-item
                                                        :label="$tc('acris-blog-author.general.mainMenuItemGeneral')"
                                                        :to="{ name: 'acris.blog.author.index' }"
                                                        class="acris-settings-item">
                                                    <template #icon>
                                                        <mt-icon name="regular-user"></mt-icon>
                                                    </template>
                                                </sw-settings-item>
                                            {% endblock %}
                                        {% endblock %}
                                    </div>
                                {% endblock %}
                            </mt-card>
                        {% endblock %}
                    </sw-card-view>
                {% endblock %}
            </template>
        {% endblock %}
    </sw-page>
{% endblock %}
